import React from 'react'
import createPersistedState from 'use-persisted-state'


const LoggedIn = ({
  id = 'credentials',
  children,
  reverse = false
}) => {
  const usePersistedState = createPersistedState(`com.box.developer.${id}`)
  const [credentials] = usePersistedState({})
  const loggedIn = credentials.logged_in

  reverse = [true, 'true', ''].includes(reverse)
  
  const show = (loggedIn && !reverse) || (!loggedIn && reverse)

  return (
    <>
      { show && children}
    </>
  )
}

export default LoggedIn